import { Tag, Tooltip } from 'antd';
import PreviewMemo from './PreviewMemo';

const memoDataColumns = [
    {
        title: "S/N",
        render: (_, __, idx) => idx + 1,
        key: "id",
        width: 70
    },
    {
        title: "Title",
        dataIndex: "title",
        key: "title",
        responsive: ['md', 'lg', 'xl'],
        render: (title) => (
            <Tooltip title={title}>
                <span>
                    {title && title.length > 10 ? `${title.substring(0, 10)}...` : title}
                </span>
            </Tooltip>
        ),
    },
    {
        title: "Creator",
        dataIndex: "creator",
        render: (_, { creator }) => creator?.name,
        key: "key",
        responsive: ['md', 'lg', 'xl'],
    },
    {
        title: "Financial Year",
        dataIndex: "financialYear",
        key: "financialYear",
        render: (_, { financialYear }) => financialYear?.value,
        responsive: ['lg', 'xl'],
    },
    {
        title: "Memo Type",
        dataIndex: "userMemoType",
        key: "memoType",
        render: (memoType) => <Tag color={memoType === "CLAIM" ? "blue" : "green"}>{memoType}</Tag>,
        responsive: ['md', 'lg', 'xl'],
    },
    {
        title: "VC Approved",
        dataIndex: "vcApproval",
        key: "vcApproval",
        render: (value) => value ? <Tag color="green">{"True"}</Tag> : <Tag color="red">{"False"}</Tag>,
        responsive: ['lg', 'xl'],
    },
    {
        title: "Bursar Approved",
        dataIndex: "bursarApproval",
        key: "bursarApproval",
        render: (value) => value ? <Tag color="green">{"True"}</Tag> : <Tag color="red">{"False"}</Tag>,
        responsive: ['lg', 'xl'],
    },
    {
        title: "Actions",
        key: "actions",
        fixed: 'right',
        width: 120,
        render: (_, memo) => <PreviewMemo memo={memo} />
    }
];

export default memoDataColumns;
